import JoditEditor from "../../components/JoditEditor/JoditEditor";
import Select from "react-select";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";
import "rc-pagination/assets/index.css";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import validator from "validator";
import { useAddContentMutation, useGetContentQuery, useUpdateContentMutation, useGetCategoriesForContentQuery, useGetGalleryQuery, useGetContentMapConfigQuery, useUpdateContentMapConfigMutation } from "../../redux/api";
import { Link, useHistory, useParams } from "react-router-dom";
import { ENV } from "config/config";
import GalleryModal from "components/Gallery/galleryModal";
import MapEditor from "../../components/MapEditor/MapEditor";
import { toast } from "react-toastify";

const {
  formatUrl,
  formatUrlManual,
  formatMetaKeywords,
  integerNumberValidator,
  objectToQueryString,
} = ENV;

const UpsertContent = () => {
  const history = useHistory();
  const { contentId } = useParams();
  const initialImage = {
    default: null,
    home: null,
    category: null,
    related: null,
    search: null,
  };

  const initialData = {
    title: "",
    url: "",
    categoryIds: [],
    images: initialImage,
    pageContent: "",
    shortDescription: "",
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    showAt: "default",
    status: "Published",
    startDate: new Date(),
    endDate: null,
    color: "#ffffff",
    isFeatured: false,
    // isActive removed from initial state as it is replaced by status
  };

  const initialMsg = {
    title: "",
    pageContent: "",
    image: "",
    categoryIds: "",
    url: "",
    shortDescription: "",
  };

  const [data, setData] = useState(initialData);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedImageType, setSelectedImageType] = useState("default");
  const [imageView, setImageView] = useState(initialImage);
  const [msg, setMsg] = useState(initialMsg);
  const [id, setId] = useState("");
  const [selectCategories, setSelectCategories] = useState([]);
  const [isOpenModal, setOpenModal] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [filters, setFilters] = useState({
    name: "",
  });

  const [resetButton, setResetButton] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const { data: categoriesForContent, isLoading: isCategoriesLoading, isFetching: isCategoriesFetching } = useGetCategoriesForContentQuery();
  const [addContent, { isLoading: isAddingContent }] = useAddContentMutation();
  const [updateContent, { isLoading: isUpdatingContent }] = useUpdateContentMutation();

  useEffect(() => {
    if (categoriesForContent) {
      const cats = categoriesForContent.categories || categoriesForContent.data || categoriesForContent || [];
      setSelectCategories(Array.isArray(cats) ? cats : []);
      if (contentId) {
        setId(contentId);
      }
    }
  }, [categoriesForContent, contentId]);
  const { data: contentRes, isLoading: isContentLoading, isFetching: isContentFetching } = useGetContentQuery(id ? window.atob(id) : undefined, { skip: !id });
  const { data: mapConfigRes } = useGetContentMapConfigQuery(id ? window.atob(id) : undefined, { skip: !id });
  const [updateContentMapConfig] = useUpdateContentMapConfigMutation();

  const [mapConfig, setMapConfig] = useState([]);
  const [cityConfig, setCityConfig] = useState([]);

  useEffect(() => {
      if (mapConfigRes && (mapConfigRes.mapConfig || mapConfigRes.cityConfig)) {
          setMapConfig(mapConfigRes.mapConfig || []);
          // Add temporary IDs to cities for frontend editing
          const citiesWithIds = (mapConfigRes.cityConfig || []).map((city, index) => ({
              ...city,
              id: city.id || Date.now() + index
          }));
          setCityConfig(citiesWithIds);
      }
  }, [mapConfigRes]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (contentRes) {
      const { EntityImages, Categories, ...rest } = contentRes;
      const images = {};
      const ImageView = {};
      if (EntityImages && EntityImages.forEach) {
        EntityImages.forEach((item) => {
          images[item.page] = item.imageId;
          ImageView[item.page] = item.Gallery.image;
        });
      }
      // Extract categoryIds from Categories array
      const categoryIds = Categories && Array.isArray(Categories) 
        ? Categories.map(cat => cat.id) 
        : [];
      const newContentRes = { ...rest, images, categoryIds };
      setImageView(ImageView);
      setData(newContentRes);
      setIsDataLoaded(true);
    }
  }, [contentRes]);

  useEffect(() => {}, []);

  useEffect(() => {}, []);

  const [galleryQs, setGalleryQs] = useState("");
  const { data: galleryRes, isLoading: isGalleryLoading, isFetching: isGalleryFetching } = useGetGalleryQuery(galleryQs, { skip: !galleryQs });
  const isGlobalLoading = isCategoriesLoading || isContentLoading || isGalleryLoading || isAddingContent || isUpdatingContent || (id && !isDataLoaded);
  useEffect(() => {
    if (galleryRes && galleryRes.gallery) {
      setGallery(galleryRes.gallery);
      setPagination(galleryRes.pagination);
    }
  }, [galleryRes]);

  const VALIDATION_ERROR_MESSAGES = {
    title: "Title field is Required.",
    pageContent: "Page Content field is Required.",
    image: "Image field is Required.",
    categoryIds: "At least one Category is Required.",
    url: "Url field is Required.",
    shortDescription: "Short Description field is Required.",
  };

  const validateField = (value, validator, errorMessage, field) => {
    if (validator(value)) {
      setMsg((prevErrors) => ({ ...prevErrors, [field]: errorMessage }));
      return false;
    } else {
      setMsg((prevErrors) => ({ ...prevErrors, [field]: "" }));
      return true;
    }
  };

  const submit = () => {
    let isValid = true;
    isValid &= validateField(
      data.title,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.title,
      "title"
    );
    isValid &= validateField(
      data.pageContent,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.pageContent,
      "pageContent"
    );
    isValid &= validateField(
      String(data.images.default ?? ""),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.image,
      "image"
    );
    // Validate categoryIds array
    if (!data.categoryIds || data.categoryIds.length === 0) {
      setMsg((prevErrors) => ({ ...prevErrors, categoryIds: VALIDATION_ERROR_MESSAGES.categoryIds }));
      isValid = false;
    } else {
      setMsg((prevErrors) => ({ ...prevErrors, categoryIds: "" }));
    }
    isValid &= validateField(
      data.url,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.url,
      "url"
    );
    isValid &= validateField(
      data.shortDescription,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.shortDescription,
      "shortDescription"
    );

    isValid &= validateField(
      String(data.startDate),
      validator.isEmpty,
      "Start Date is Required.",
      "startDate"
    );

    if (isValid) {
      // Clean city data - remove temporary frontend IDs
      const cleanCityConfig = cityConfig.map(({ id, ...rest }) => rest);
      
      if (id) {
        updateContent(data).then((res) => {
          if (!res.error) {
            updateContentMapConfig({ id: window.atob(id), mapConfig, cityConfig: cleanCityConfig }).then((mapRes) => {
                if (!mapRes.error) {
                    history.push("/cms");
                }
            });
          }
        });
      } else {
        addContent(data).then((res) => {
          if (!res.error && res.data && res.data.content && res.data.content.id) {
            updateContentMapConfig({ id: res.data.content.id, mapConfig, cityConfig: cleanCityConfig }).then((mapRes) => {
                if (!mapRes.error) {
                    history.push("/cms");
                }
            });
          }
        });
      }
    }
  };



  const setImage = (img) => {
    setData((prevData) => {
      const { Gallery, ...rest } = prevData;

      // Update the image for the selected type
      const updatedImages = {
        ...prevData.images, // Keep existing images
        [selectedImageType]: img.id, // Update the selected type
      };

      return { ...rest, images: updatedImages };
    });

    setImageView((prevViews) => ({
      ...prevViews,
      [selectedImageType]: img.image, // Update the preview for the selected type
    }));

    setMsg((prevErrors) => ({ ...prevErrors, image: "" }));
  };

  const fetchGallery = () => {
    const qs = objectToQueryString({ page: 1, limit: 12, isActive: true });
    setGalleryQs(qs);
    setOpenModal(true);
  };

  const onPageChange = async (page) => {
    const qs = objectToQueryString({ page, ...filters });
    setGalleryQs(qs);
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ name: "" });
    setGalleryQs("");
  };

  const applyFilters = () => {
    if (filters && filters.name) {
      setResetButton(true);
      const qs = objectToQueryString({ page: 1, limit: 10, ...filters });
      setGalleryQs(qs);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };



  return (
    <>
      {isGlobalLoading ? (
        <FullPageLoader />
      ) : (
        <Container>
          <Row>
            <Col md="12">
              <Card className="pb-3 table-big-boy">
                <Card.Header>
                  <Card.Title as="h4">
                    {id ? "Edit " : "Add "} Content
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>
                          Title<span className="text-danger"> *</span>
                        </label>
                        <Form.Control
                          className={msg.title ? `on-error` : ``}
                          value={data.title ? data.title : ""}
                          onChange={(e) => {
                            const newName = e.target.value;
                            const newUrl = formatUrl(newName);
                            setData({
                              ...data,
                              title: newName,
                              url: newUrl,
                              metaTitle: newName,
                              metaKeyword: formatMetaKeywords(newUrl),
                            });
                            setMsg((prevErrors) => ({
                              ...prevErrors,
                              title: "",
                              url: "",
                            }));
                          }}
                          placeholder="Title"
                          type="text"
                        ></Form.Control>
                        <span className={msg.title ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.title}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          URL<span className="text-danger">*</span>
                        </label>
                        <Form.Control
                          className={msg.url ? `on-error` : ``}
                          placeholder="Enter url"
                          type="text"
                          name="url"
                          onChange={(e) => {
                            setData({
                              ...data,
                              url: formatUrlManual(e.target.value),
                            });
                            setMsg((prevErrors) => ({
                              ...prevErrors,
                              url: "",
                            }));
                          }}
                          value={data?.url}
                          required
                        />
                        <span className={msg.url !== "" ? `` : `d-none`}>
                          <label className="pl-1 text-danger">{msg.url}</label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <div className="d-flex pt-3 align-items-center">
                          <label className="mr-3">Show At</label>
                          <label className="right-label-radio mr-3 mb-2">
                            Default
                            <input
                              name="showAt"
                              type="radio"
                              value="default"
                              checked={data.showAt === "default"}
                              onChange={(e) => {
                                setData({ ...data, showAt: "default" });
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="right-label-radio mr-3 mb-2">
                            Featured
                            <input
                              name="showAt"
                              type="radio"
                              value="featured"
                              checked={data.showAt === "featured"}
                              onChange={(e) => {
                                setData({ ...data, showAt: "featured" });
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="right-label-radio mr-3 mb-2">
                            First Banner Post
                            <input
                              name="showAt"
                              type="radio"
                              value="firstBanner"
                              checked={data.showAt === "firstBanner"}
                              onChange={(e) => {
                                setData({ ...data, showAt: "firstBanner" });
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <label className="right-label-radio mr-3 mb-2">
                            Second Banner Post
                            <input
                              name="showAt"
                              type="radio"
                              value="secondBanner"
                              checked={data.showAt === "secondBanner"}
                              onChange={(e) => {
                                setData({ ...data, showAt: "secondBanner" });
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Make it featured on listing page
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            name="isFeatured"
                            onChange={(e) =>
                              setData({
                                ...data,
                                isFeatured: !data.isFeatured,
                              })
                            }
                            checked={data?.isFeatured}
                          />
                          <span className="checkmark"></span>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Add Interactive Map
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            name="isAddMap"
                            onChange={(e) =>
                              setData({
                                ...data,
                                isAddMap: !data.isAddMap,
                              })
                            }
                            checked={data?.isAddMap || false}
                          />
                          <span className="checkmark"></span>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  {data?.isAddMap && (
                      <Row>
                          <Col md="12">
                              <h4 className="mt-4">Interactive Map Configuration</h4>
                              <MapEditor 
                                  mapConfig={mapConfig} 
                                  cityConfig={cityConfig} 
                                  onChange={(newConfig) => {
                                      setMapConfig(newConfig.mapConfig);
                                      setCityConfig(newConfig.cityConfig);
                                  }}
                              />
                          </Col>
                      </Row>
                  )}
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Status</label>
                        <Form.Control
                          as="select"
                          value={data.status}
                          onChange={(e) => setData({ ...data, status: e.target.value })}
                        >
                          <option value="Draft">Draft</option>
                          <option value="Published">Published</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                       <Form.Group>
                        <label>Color</label>
                        <Form.Control
                          type="color"
                          value={data.color || "#ffffff"}
                          onChange={(e) => setData({ ...data, color: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Start Date<span className="text-danger"> *</span></label>
                         <br />
                          {/* Assuming DatePicker is imported or using type="date" */}
                          {/* Use type="date" for simplicity if DatePicker component isn't standard, 
                              but file has DatePicker imported in upsertEvent.js, checking here... 
                              It was NOT imported here. I will use standard date input or add DatePicker import.
                              Wait, UpsertEvent.js had import DatePicker from "react-datepicker";
                              UpsertContent.js line 1-11 did NOT have it. 
                              I should add the import first.
                           */}
                           <input 
                              type="date"
                              className="form-control"
                              value={data.startDate ? new Date(data.startDate).toISOString().split('T')[0] : ''}
                              onChange={(e) => setData({ ...data, startDate: new Date(e.target.value) })}
                           />
                           {/* To be safe with formats, I'll stick to simple date input for now or add the import. 
                               The user said "For startDate by defualt current date will be selected".
                               Let's use standard input type="date" to avoid missing dependency issues 
                               unless I see it used elsewhere in THIS file in a previous turn (I didn't).
                           */}
                           <span className={msg.startDate ? `` : `d-none`}>
                              <label className="pl-1 text-danger">{msg.startDate}</label>
                           </span>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>End Date</label>
                        <input 
                              type="date"
                              className="form-control"
                              value={data.endDate ? new Date(data.endDate).toISOString().split('T')[0] : ''}
                              onChange={(e) => setData({ ...data, endDate: new Date(e.target.value) })}
                           />
                      </Form.Group>
                    </Col>
                    
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Categories<span className="text-danger">*</span>
                          {/* <small className="text-muted ml-2">(Hold Ctrl/Cmd to select multiple)</small> */}
                        </label>

                        <Select
                          isMulti
                          options={
                            selectCategories &&
                            selectCategories.map((option) => ({
                              value: option.id,
                              label: option.name,
                            }))
                          }
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: "var(--input-bg)",
                              borderColor: "var(--input-border)",
                              color: "var(--input-text)",
                              boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(248, 152, 28, 0.25)" : base.boxShadow,
                              "&:hover": {
                                borderColor: "var(--accent-primary)",
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              backgroundColor: "var(--card-bg)",
                              zIndex: 9999,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isFocused ? "var(--bg-hover)" : "var(--card-bg)",
                              color: "var(--text-primary)",
                              "&:active": {
                                backgroundColor: "var(--accent-primary)",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "var(--bg-secondary)",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "var(--text-primary)",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "var(--text-secondary)",
                              "&:hover": {
                                backgroundColor: "var(--accent-danger)",
                                color: "#ffffff",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: "var(--text-primary)",
                            }),
                            input: (base) => ({
                                ...base,
                                color: "var(--text-primary)",
                            })
                          }}
                          value={
                            selectCategories &&
                            selectCategories
                              .filter((option) =>
                                (data.categoryIds || []).includes(option.id)
                              )
                              .map((option) => ({
                                value: option.id,
                                label: option.name,
                              }))
                          }
                          onChange={(selectedOptions) => {
                             const ids = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                             setData({ ...data, categoryIds: ids });
                             setMsg((prevErrors) => ({
                               ...prevErrors,
                               categoryIds: "",
                             }));
                           }}
                        />
                        <span className={msg.categoryIds !== "" ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.categoryIds}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Image<span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <Button
                            className="btn-filled pull-right mt-3"
                            variant="info"
                            onClick={fetchGallery}
                          >
                            Choose Image
                          </Button>
                          <Form.Control
                            as="select"
                            className="image-select"
                            value={selectedImageType}
                            onChange={(e) =>
                              setSelectedImageType(e.target.value)
                            }
                          >
                            <option value="default">Default</option>
                            <option value="home">Home</option>
                            <option value="category">Listing Page</option>
                            <option value="related">Related</option>
                            <option value="search">Search</option>
                          </Form.Control>
                        </div>
                      </Form.Group>
                      <span className={msg.image !== "" ? `` : `d-none`}>
                        <label className="pl-1 text-danger">{msg.image}</label>
                      </span>
                      {imageView &&
                        Object.entries(imageView || {}).map(([type, image]) => (
                          <Form.Group key={type}>
                            <label>
                              {type.charAt(0).toUpperCase() + type.slice(1)}:
                            </label>
                            {image ? (
                              <img
                                src={`${ENV.assetsUrl}gallery/${image}`}
                                id={`imageUploader-${type}`}
                                className="image-fluid"
                                style={{ width: "30%", height: "30%" }}
                                alt={`${type}-gallery-image`}
                              />
                            ) : (
                              <span>No image selected</span>
                            )}
                          </Form.Group>
                        ))}
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" sm="6">
                      <label>
                        Text / Description
                        <span className="text-danger"> *</span>
                      </label>
                      <JoditEditor
                        value={data.pageContent || ""}
                        onChange={(content) => {
                          setData({ ...data, pageContent: content });
                          setMsg({ ...msg, pageContent: "" });
                        }}
                      />
                      <span className={msg.pageContent ? `` : `d-none`}>
                        <label className="pl-1 text-danger">
                          {msg.pageContent}
                        </label>
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Short Description{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          className={msg.shortDescription ? `on-error` : ``}
                          placeholder="Enter short description"
                          type="text"
                          name="shortDescription"
                          onChange={(e) => {
                            setData({
                              ...data,
                              shortDescription: e.target.value,
                            });
                            setMsg({ ...msg, shortDescription: "" });
                          }}
                          value={data?.shortDescription}
                        />
                        <span className={msg.shortDescription ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.shortDescription}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Title</label>
                        <Form.Control
                          placeholder="Enter Meta tiltes"
                          type="text"
                          name="metaTitle"
                          onChange={(e) =>
                            setData({ ...data, metaTitle: e.target.value })
                          }
                          value={data?.metaTitle}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Keywords</label>
                        <Form.Control
                          placeholder="Enter Meta Keywords"
                          type="text"
                          name="metaKeyword"
                          onChange={(e) =>
                            setData({ ...data, metaKeyword: e.target.value })
                          }
                          value={data?.metaKeyword}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Description</label>
                        <Form.Control
                          placeholder="Enter Meta Description"
                          type="text"
                          name="metaDescription"
                          onChange={(e) =>
                            setData({
                              ...data,
                              metaDescription: e.target.value,
                            })
                          }
                          value={data?.metaDescription}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="12" sm="6">
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="mr-2">
                          <Link
                            to={"/cms"}
                            className="outline-button btn btn-primary mt-3"
                          >
                            Back
                          </Link>
                        </div>
                        <Button
                          className="btn-filled pull-right mt-3"
                          type="submit"
                          variant="info"
                          onClick={submit}
                        >
                          {id ? "Update " : "Add "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <GalleryModal
            isOpenModal={isOpenModal}
            setOpenModal={setOpenModal}
            setImage={setImage}
            gallery={gallery}
            pagination={pagination}
            onPageChange={onPageChange}
            reset={reset}
            applyFilters={applyFilters}
            filters={filters}
            setFilters={setFilters}
            resetButton={resetButton}
          />
        </Container>
      )}
    </>
  );
};

export default UpsertContent;
